import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (costProfile) =>
    present(
      repository
        .getCostProfileCostsHistory(costProfile)
        .then((costProfileCostsHistory) => ({
          costProfile,
          costProfileCostsHistory,
        }))
        .catch(() => Promise.reject(costProfile)),
    );
}

export type { Interactor };

export { createInteractor };
